module.exports = __webpack_public_path__ + "static/media/study.172df2e8.svg";